<!-- =========================================================================================
  File Name: AttendeeList.vue
  Description: Attendee List
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->

<template>
  <div id="page-user-list" v-show="pageLoaded">
    <div class="header-custome" v-if="!enableCheckinModule">
      <h3>
        {{ $t("AttendeeList") ? $t("AttendeeList") : "Attendee List" }}
        <span>{{
          gridSelectedRows ? "(Rows Selected: " + gridSelectedRows + ")" : ""
        }}</span>
      </h3>
      <vs-button
        v-if="prevRoute && prevRoute.name == 'registration-dashboard'"
        @click="$router.push('/event/reg-dashboard?activeTab=1')"
        >Go to Registration</vs-button
      >
      <div class="knowlg-base-wrap-sec hidden">
        <a href="/pages/knowledge-base/category-attendees/question-2">
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-help-circle"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
          </span>
          Need help with this section?
        </a>
      </div>
    </div>
    <div
      class="vx-card p-6 blank-attendee"
      v-show="
        attendeeData.length < 1 &&
        !RegistrationTypeFilterVal &&
        !LoginTypeFilterVal &&
        !selectedRoles
      "
    >
      <div class="entity-create-sec">
        <div class="emtity-icon">
          <img src="../../assets/images/blank-page-images/attendee.png" />
          <!--<feather-icon class="" icon="UsersIcon" />-->
        </div>
        <div class="entity-create-desc">
          <h2>Create an Attendee</h2>
          <p>
            Start by inviting attendees to your event. You can update avatar,
            name, email, headline, bio, and social profiles. You can also use
            the bulk import option and send bulk mails to attendees after you
            have added them!
          </p>
          <div class="entity-setup-buttons">
            <vs-button
              color="primary"
              type="border"
              class="new-entity-add-button"
              @click="getDefaultSettings"
              >ADVANCED SETTINGS</vs-button
            >
            <vs-button
              color="primary"
              type="filled"
              class="new-entity-add-button"
              @click="$router.push('/event/attendee/add')"
              >ADD NEW ATTENDEE</vs-button
            >
            <vs-button
              color="primary"
              type="border"
              class="new-entity-add-button"
              @click="popupActive = true"
              >IMPORT ATTENDEES</vs-button
            >
          </div>
        </div>
      </div>
    </div>
    <div
      class="vx-card p-6"
      v-show="
        attendeeData.length > 0 ||
        RegistrationTypeFilterVal ||
        LoginTypeFilterVal ||
        selectedRoles
      "
    >
      <div
        v-if="!enableCheckinModule"
        class="vx-row w-full flex flex-wrap items-center justify-between list-top-wrap"
      >
        <!-- ITEMS PER PAGE -->
        <div class="list-top-left md:w-4/12 w-full">
          <div class="flex items-center justify-start">
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <div
                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
              >
                <span class="mr-2" v-if="attendeeData_duplicate == ''"
                  >{{
                    currentPage * paginationPageSize - (paginationPageSize - 1)
                  }}
                  -
                  {{
                    attendeeData.length - currentPage * paginationPageSize > 0
                      ? currentPage * paginationPageSize
                      : attendeeData.length
                  }}
                  of {{ attendeeData.length }}</span
                >
                <span class="mr-2" v-else
                  >{{
                    currentPage * paginationPageSize - (paginationPageSize - 1)
                  }}
                  -
                  {{
                    attendeeData_duplicate.length -
                      currentPage * paginationPageSize >
                    0
                      ? currentPage * paginationPageSize
                      : attendeeData_duplicate.length
                  }}
                  of {{ attendeeData_duplicate.length }}</span
                >
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
              <vs-dropdown-menu>
                <vs-dropdown-item
                  @click="
                    gridApi.paginationSetPageSize(10);
                    gridPageRows = 10;
                  "
                >
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item
                  @click="
                    gridApi.paginationSetPageSize(20);
                    gridPageRows = 20;
                  "
                >
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item
                  @click="
                    gridApi.paginationSetPageSize(30);
                    gridPageRows = 30;
                  "
                >
                  <span>30</span>
                </vs-dropdown-item>
                <vs-dropdown-item
                  @click="
                    gridApi.paginationSetPageSize(50);
                    gridPageRows = 50;
                  "
                >
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item
                  @click="
                    gridApi.paginationSetPageSize(100);
                    gridPageRows = 100;
                  "
                >
                  <span>100</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
            <div class="select-row-check">
              <span class="ml-4">Select {{ gridPageRows }} Rows :</span>
              <vs-checkbox
                class="filter-wrapper"
                @change="selectPageRows"
                v-model="isselectPageRows"
              />
            </div>
          </div>
        </div>
        <!--ADD Attendee-->
        <div class="list-top-right md:w-8/12 w-full">
          <vs-popup
            mailpopup
            class="holamundo customnewpopup"
            title="Mail Preview"
            :active.sync="popupActiveMail"
          >
            <div class="vx-col md:w-1/1 w-full mt-4">
              <label>Choose Template</label>
              <v-select
                :clearable="false"
                label="DisplayLabel"
                v-model="selectedMailPath"
                :options="mailtplData"
                @input="getMailTpl"
              />
              <div class="mail-template-switch-btn">
                <!-- <ul>
                  <li
                    id="reminderTemp"
                    class="active"
                    @click="setPreviewMailTemplate('Reminder')"
                  >
                    Reminder
                  </li>
                  <li
                    v-if="Environment != 'EDU'"
                    id="announcementTemp"
                    @click="setPreviewMailTemplate('Announcement')"
                  >
                    Announcement
                  </li>
                </ul> -->
              </div>
            </div>
            <vs-tabs>
              <vs-tab label="Preview">
                <div class="tab-text">
                  <div class="vx-row" style="width: 622px">
                    <div class="vx-col md:w-1/1 w-full mt-4 email-temp-head">
                      <h3>Subject: {{ MailSubject }}</h3>
                    </div>
                    <br />
                    <div v-html="MailHtml"></div>
                    <br />
                    <div class="vx-col md:w-1/1 w-full mt-4">
                      <div click="sendbtn-section">
                        <vs-button
                          color="rgb(76, 139, 246)"
                          type="filled"
                          @click="cancelMail(null)"
                          >Cancel</vs-button
                        >
                        <vs-button
                          class="mail-btn"
                          color="rgb(76, 139, 246)"
                          type="filled"
                          @click="sendMail"
                          >Send Mail</vs-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </vs-tab>
              <vs-tab label="Edit">
                <div class="tab-text">
                  <div class="vx-row" style="width: 622px">
                    <div class="vx-col md:w-1/1 w-full mt-4">
                      Subject:
                      <vs-input
                        class="inputx w-full mt-4"
                        v-model="MailSubject"
                        v-validate="'required'"
                        name="Subject"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('Subject')"
                        >{{ errors.first("Subject") }}</span
                      >
                      <br />Body:
                      <ckeditor
                        class="desc-event"
                        v-model="MailHtml"
                        :config="editorConfig"
                      ></ckeditor>
                      <br />
                      <div click="sendbtn-section">
                        <vs-button
                          color="rgb(76, 139, 246)"
                          type="filled"
                          @click="cancelMail(null)"
                          >Cancel</vs-button
                        >
                        <vs-button
                          class="mail-btn"
                          color="rgb(76, 139, 246)"
                          type="filled"
                          @click="before_save"
                          >Save</vs-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </vs-tab>
            </vs-tabs>
          </vs-popup>

          <vs-popup
            mailpopup
            class="holamundo customnewpopup"
            title="QR Mail Preview"
            :active.sync="popupActiveMailQR"
          >
            <div class="vx-col md:w-1/1 w-full mt-2">
              <label>Choose Template</label>
              <v-select
                :clearable="false"
                label="DisplayLabel"
                v-model="selectedMailPath"
                :options="mailtplData"
                @input="getMailTpl"
              />
              <label>Receipients emails with comma seperated</label>
              <vs-input
                placeholder="ex: abc@xyz.com, xyz@abc.com"
                class="inputx w-full mt-4"
                v-model="qrRecipients"
                v-validate="'required'"
                name="receipient"
              />
            </div>
            <vs-tabs>
              <vs-tab label="Preview">
                <div class="tab-text">
                  <div class="vx-row" style="width: 622px">
                    <div class="vx-col md:w-1/1 w-full mt-4 email-temp-head">
                      <h3>Subject: {{ MailSubject }}</h3>
                    </div>
                    <br />
                    <div v-html="MailHtml"></div>
                    <br />
                    <div class="vx-col md:w-1/1 w-full mt-4">
                      <div click="sendbtn-section">
                        <vs-button
                          color="rgb(76, 139, 246)"
                          type="filled"
                          @click="cancelMail('QR')"
                          >Cancel</vs-button
                        >
                        <vs-button
                          class="mail-btn"
                          color="rgb(76, 139, 246)"
                          type="filled"
                          @click="--sendMailQR"
                          >Send Mail</vs-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </vs-tab>
              <vs-tab label="Edit">
                <div class="tab-text">
                  <div class="vx-row" style="width: 622px">
                    <div class="vx-col md:w-1/1 w-full mt-4">
                      Subject:
                      <vs-input
                        class="inputx w-full mt-4"
                        v-model="MailSubject"
                        v-validate="'required'"
                        name="Subject"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('Subject')"
                        >{{ errors.first("Subject") }}</span
                      >
                      <br />Body:
                      <ckeditor
                        class="desc-event"
                        v-model="MailHtml"
                        :config="editorConfig"
                      ></ckeditor>
                      <br />
                      <div click="sendbtn-section">
                        <vs-button
                          color="rgb(76, 139, 246)"
                          type="filled"
                          @click="cancelMail('QR')"
                          >Cancel</vs-button
                        >
                        <vs-button
                          class="mail-btn"
                          color="rgb(76, 139, 246)"
                          type="filled"
                          @click="before_save"
                          >Save</vs-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </vs-tab>
            </vs-tabs>
          </vs-popup>

          <!--<vs-popup
          mailpopup
          class="holamundo customnewpopup"
          title="Mail Template Edit"
          :active.sync="popupActiveMailUpdate"
        >
          
        </vs-popup>-->

          <vx-tooltip text="Send mail to Attendee" position="bottom">
            <vs-button
              class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
              type="border"
              @click="getMailTpls(null)"
              >Send Mail</vs-button
            >
          </vx-tooltip>
          <!--<vs-button type="gradient mr-4" @click="getMailTplRaw">Edit Mail</vs-button>-->
          <!--
        <vs-button color="success" type="gradient mr-4" @click="changeStatus(true)">Active</vs-button>
        <vs-button color="danger" type="gradient mr-4" @click="changeStatus(false)">Inactive</vs-button>
        -->
          <vx-tooltip text="Add New Attendee" position="bottom">
            <vs-button
              class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
              color="rgb(76, 139, 246)"
              type="filled"
              v-on:click="addRecord()"
              >Add New</vs-button
            >
          </vx-tooltip>

          <v-select
            class="sm:mr-4 mr-0 sm:w-1/6 w-full sm:order-normal order-3 sm:mt-0 mt-4"
            placeholder="Registration Type"
            label="RegistrationType"
            :options="RegistrationTypeFilters"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="RegistrationTypeFilterVal"
          />

          <v-select
            class="sm:mr-4 mr-0 sm:w-1/6 w-full sm:order-normal order-3 sm:mt-0 mt-4"
            placeholder="Login Type"
            :options="['Active', 'Inactive']"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="LoginTypeFilterVal"
          />

          <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          <vs-input
            class="sm:mr-4 mr-0 sm:w-1/6 w-full sm:order-normal order-3 sm:mt-0 mt-4"
            v-model="searchQuery"
            @input="updateSearchQuery"
            placeholder="Search..."
          />
          <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

          <!-- ACTION - DROPDOWN -->
          <vx-tooltip text="Actions" position="bottom">
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <div
                class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32"
              >
                <span class="mr-2 leading-none" v-if="selectedFilter == null"
                  >Actions</span
                >
                <span
                  class="mr-2 leading-none"
                  v-else-if="selectedFilter == 'Login'"
                  ><small> Login</small></span
                >
                <span
                  class="mr-2 leading-none"
                  v-else-if="selectedFilter == 'Not Login'"
                  ><small> Not Login</small></span
                >
                <feather-icon
                  icon="ChevronDownIcon"
                  svgClasses="h-4 w-4"
                  v-if="selectedFilter == null"
                />
                <feather-icon
                  icon="FilterIcon"
                  svgClasses="h-4 w-4"
                  v-if="
                    selectedFilter == 'Login' || selectedFilter == 'Not Login'
                  "
                />
              </div>

              <vs-dropdown-menu class="dropdown-width">
                <vs-dropdown-item @click="registrationTypes">
                  <span class="flex items-center">
                    <feather-icon
                      icon="ListIcon"
                      svgClasses="h-4 w-4"
                      class="mr-2"
                    />
                    <span>Registration Types</span>
                  </span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="getfilterCriterias">
                  <span class="flex items-center">
                    <feather-icon
                      icon="ListIcon"
                      svgClasses="h-4 w-4"
                      class="mr-2"
                    />
                    <span>Filter Criterias</span>
                  </span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="changeStatus(true)">
                  <span class="flex items-center">
                    <feather-icon
                      icon="ArchiveIcon"
                      svgClasses="h-4 w-4"
                      class="mr-2"
                    />
                    <span>Make Active</span>
                  </span>
                </vs-dropdown-item>

                <vs-dropdown-item @click="changeStatus(false)">
                  <span class="flex items-center">
                    <feather-icon
                      icon="ArchiveIcon"
                      svgClasses="h-4 w-4"
                      class="mr-2"
                    />
                    <span>Make InActive</span>
                  </span>
                </vs-dropdown-item>

                <vs-dropdown-item @click="generateQR()">
                  <span class="flex items-center">
                    <feather-icon
                      icon="FileIcon"
                      svgClasses="h-4 w-4"
                      class="mr-2"
                    />
                    <span>Generate QR</span>
                  </span>
                </vs-dropdown-item>

                <vs-dropdown-item @click="getMailTpls('QR')">
                  <span class="flex items-center">
                    <feather-icon
                      icon="MailIcon"
                      svgClasses="h-4 w-4"
                      class="mr-2"
                    />
                    <span>Send QR</span>
                  </span>
                </vs-dropdown-item>

                <vs-dropdown-item @click="exportSelected()">
                  <span class="flex items-center">
                    <feather-icon
                      icon="FileIcon"
                      svgClasses="h-4 w-4"
                      class="mr-2"
                    />
                    <span>Download CSV Export</span>
                  </span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="NotificationReport()">
                  <span class="flex items-center">
                    <feather-icon
                      icon="FileIcon"
                      svgClasses="h-4 w-4"
                      class="mr-2"
                    />
                    <span>Download Notification Report</span>
                  </span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="copySpeaker()">
                  <span class="flex items-center">
                    <feather-icon
                      icon="FileIcon"
                      svgClasses="h-4 w-4"
                      class="mr-2"
                    />
                    <span>Quick Create Speaker</span>
                  </span>
                </vs-dropdown-item>

                <vs-dropdown-item @click="deleteRecord()">
                  <span class="flex items-center">
                    <feather-icon
                      icon="TrashIcon"
                      svgClasses="h-4 w-4"
                      class="mr-2"
                    />
                    <span>Delete Record(s)</span>
                  </span>
                </vs-dropdown-item>

                <vs-dropdown-item @click="loggedInUsersFilter()">
                  <span class="flex items-center">
                    <feather-icon
                      icon="ArchiveIcon"
                      svgClasses="h-4 w-4"
                      class="mr-2"
                    />
                    <span>Filter Logged In(Today)</span>
                  </span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="notLoggedInUsersFilter()">
                  <span class="flex items-center">
                    <feather-icon
                      icon="ArchiveIcon"
                      svgClasses="h-4 w-4"
                      class="mr-2"
                    />
                    <span>Filter Not Logged In(Today)</span>
                  </span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </vx-tooltip>
          <vx-tooltip text="Cancel" position="bottom">
            <vs-button
              v-if="selectedFilter == 'Login' || selectedFilter == 'Not Login'"
              color="primary"
              type="border"
              class="setting-btn cancel-button"
              title=""
              @click="CloseFilterLogin"
            >
              <feather-icon icon="XCircleIcon" svgClasses="h-4 w-4" />
            </vs-button>
          </vx-tooltip>

          <vx-tooltip
            :text="
              $t('AttendeeImport') ? $t('AttendeeImport') : 'Import Attendee'
            "
            position="bottom"
          >
            <vs-button
              color="primary"
              type="border"
              class="ml-3 import-buttn-wrap"
              @click="popupActive = true"
              ><feather-icon icon="ArrowUpCircleIcon" svgClasses="h-4 w-4"
            /></vs-button>
          </vx-tooltip>
          <vs-popup
            classContent="popup-example"
            class="holamundo"
            title="Registration Types"
            :active.sync="popupActiveRT"
          >
            <!--items-center-->
            <!-- <vs-button color="primary" @click="addRegistrationType"
              >Add New</vs-button
            > -->
            <div class="flex flex-wrap" style="min-height: 400px">
              <div class="flex-grow">
                <div>
                  <vs-table :data="RegistrationTypes">
                    <template slot="thead">
                      <vs-th>Registration Type</vs-th>
                      <vs-th>Color Code</vs-th>
                      <vs-th>Action</vs-th>
                    </template>
                    <template slot-scope="{ data }">
                      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="data[indextr].RegistrationType">{{
                          data[indextr].RegistrationType
                        }}</vs-td>
                        <vs-td :data="data[indextr].ColorCode">{{
                          data[indextr].ColorCode
                        }}</vs-td>
                        <vs-td :data="data[indextr].RegistrationTypeId">
                          <feather-icon
                            icon="Edit3Icon"
                            title="Edit Admin"
                            svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                            @click="editRegistrationType(data[indextr])"
                          />
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </div>
            </div>
          </vs-popup>
          <vs-popup
            class="holamundo"
            title="Registration Type"
            :active.sync="popupActiveRTF"
          >
            <vs-input
              type="hidden"
              v-model="RegistrationTypeDetail.RegistrationTypeId"
            />
            <div class="w-full group-creation-wrapper">
              <label class="mb-2">Resgistration Type</label>
              <vs-input
                class="inputx input-track-name mb-3 w-full"
                v-model="RegistrationTypeDetail.RegistrationType"
              />
              <div class="group-person-count">
                <label class="mr-5">Color Code</label>
                <vs-input
                  class="w-20 h-20"
                  type="color"
                  v-model="RegistrationTypeDetail.ColorCode"
                />
                <vs-input
                  class="inputx input-track-name mb-3 w-full"
                  v-model="RegistrationTypeDetail.ColorCode"
                />
              </div>
            </div>
            <div align="right">
              <vs-button
                color="rgb(76, 139, 246)"
                type="filled"
                @click="saveRegistrationType"
                >Save</vs-button
              >
            </div>
          </vs-popup>
          <vx-tooltip text="Advance Settings" position="bottom">
            <vs-button
              color="primary"
              type="border"
              class="ml-3 setting-btn"
              @click="getSettings"
            >
              <img src="../../assets/images/settings.svg" alt="settings" />
            </vs-button>
          </vx-tooltip>
        </div>
      </div>
      <div
        v-if="enableCheckinModule"
        class="w-full flex flex-wrap items-center justify-between list-top-wrap"
      >
        <div class="list-top-left md:w-3/12 w-full">
          <h3>
            {{ $t("AttendeeList") ? $t("AttendeeList") : "Attendee List" }}
            <span>
              {{
                gridSelectedRows
                  ? "(Rows Selected: " + gridSelectedRows + ")"
                  : ""
              }}
            </span>
          </h3>
        </div>
        <div class="list-top-right md:w-9/12 w-full pl-0 md:pl-2">
          <div class="user-management-table-filter sm:mt-0 mt-4">
            <feather-icon icon="FilterIcon" svgClasses="h-6 w-6" class="ml-1" />
            <v-select
              class="w-full sm:order-normal order-3"
              placeholder="Role"
              label="Name"
              :options="checkinRoleList"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="selectedRoles"
              :reduce="(item) => item.RoleId"
              @clear="selectedRoles = []"
            />
          </div>
          <div class="user-management-search sm:mt-0 mt-4">
            <feather-icon icon="SearchIcon" svgClasses="h-6 w-6" class="ml-1" />
            <vs-input
              class="mr-0 w-full sm:order-normal order-3"
              v-model="searchQuery"
              @input="updateSearchQuery"
              placeholder="Search User"
            />
          </div>

          <vs-button
            class="sm:mr-2 mr-0 sm:w-auto sm:order-normal order-3 sm:mt-0 mt-4 bulk_import"
            color="rgb(0,0,0)"
            type="border"
            style="width: 100px !important"
            @click="exportSelectedForGeoCheckin()"
            >EXPORT</vs-button
          >
          <vs-button
            class="sm:mr-2 mr-0 sm:w-auto sm:order-normal order-3 sm:mt-0 mt-4 bulk_import"
            color="rgb(0,0,0)"
            type="border"
            style="width: 100px !important"
            @click="popupActiveRole = true"
            >ROLES</vs-button
          >
          <vs-button
            class="sm:mr-2 mr-0 sm:w-auto sm:order-normal order-3 sm:mt-0 mt-4 bulk_import"
            color="rgb(0,0,0)"
            type="border"
            style="width: 160px !important"
            @click="popupActiveDesignation = true"
            >JOB TITLES</vs-button
          >
          <vs-button
            class="sm:mr-2 mr-0 sm:w-auto sm:order-normal order-3 sm:mt-0 mt-4 bulk_import"
            color="rgb(0,0,0)"
            type="border"
            @click="popupActive = true"
            >BULK IMPORT</vs-button
          >
          <vs-button
            class="sm:w-auto sm:order-normal order-3 sm:mt-0 mt-4 add-line-button flex items-center justify-center user-add"
            color="#00ccfe"
            type="filled"
            v-on:click="openAddUserPopup()"
            ><feather-icon icon="UserPlusIcon" svgClasses="h-5 w-5" />&nbsp; ADD
            USER</vs-button
          >
        </div>
        <div v-if="paramLocationId && urlLocationData.length > 0" class="mt-2">
          <div class="attendee-location-details">
            <router-link to="/event/checkin/location">
              <!-- {{ "<< Back" }} -->
              <feather-icon
                icon="ArrowLeftIcon"
                svgClasses="h-6 w-6"
                class=""
              />
            </router-link>
            <p class="ml-2" style="">{{ urlLocationData[0].Name }}</p>
          </div>
        </div>
      </div>
      <vs-popup
        class="holamundo"
        :title="$t('AttendeeImport') ? $t('AttendeeImport') : 'Import Attendee'"
        :active.sync="popupActive"
      >
        <div class="import-attendee-wrapper">
          <div class="template-download">
            <h4>Download the template</h4>
            <a
              color="primary"
              type="filled"
              class="mt-3 btn"
              :href="
                enableCheckinModule
                  ? getCDNUrl(
                      con.resourceBaseUrl +
                        'OA_UAT%2FDownloads%2FTemplate_User.xlsx'
                    )
                  : 'https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDownloads%2FTemplate_Attendee.xlsx?alt=media&token=af0ac634-c0d2-4034-baec-1e552285635f'
              "
              >Download</a
            >
          </div>
          <!--
              <div class="add-content mt-5">
                <h4>Add content</h4>
                <p>Add content to the template. Please don’t delete or rename columns, leave them empty if unused.</p>
              </div>
            -->
          <div class="upload-file mt-5">
            <h4>Upload your file</h4>
            <div class="file-up-section">
              <p>Select XLSX file</p>
              <input
                type="file"
                id="attendee_file"
                accept=".csv, .xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              />
              <vs-button
                color="rgb(76, 139, 246)"
                type="filled"
                class="sub-btn"
                v-on:click="UploadAttendee"
                >Upload</vs-button
              >
            </div>
          </div>
        </div>
      </vs-popup>
      <!-- AgGrid Table -->
      <ag-grid-vue
        v-if="attendeeData_duplicate == ''"
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-full my-4 ag-grid-table"
        :columnDefs="enableCheckinModule ? checkinColumnDefs : columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="attendeeData"
        :rowHeight="rowHeight"
        rowSelection="multiple"
        rowMultiSelectWithClick="false"
        suppressRowClickSelection="true"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        @selection-changed="onSelectionChanged"
      ></ag-grid-vue>
      <ag-grid-vue
        v-else
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-full my-4 ag-grid-table"
        :columnDefs="enableCheckinModule ? checkinColumnDefs : columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="attendeeData_duplicate"
        rowSelection="multiple"
        rowMultiSelectWithClick="false"
        suppressRowClickSelection="true"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        @selection-changed="onSelectionChanged"
      ></ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
    <div v-if="popupActive2 == true">
      <attendee-settings
        :data="popupActive2"
        :key="attendeeSettingsResetKey"
        v-on:saveSettingsData="saveSettingsData"
      />
    </div>
    <vs-popup
      class="holamundo"
      title="Filter Criterias"
      fullscreen="fullscreen"
      :active.sync="popupFilterCriteria"
    >
      <filter-criterias
        :key="filterCriteriaKey"
        @closePopupFilterCriteria="popupFilterCriteria = false"
      />
    </vs-popup>

    <!--adduser-->
    <vs-popup
      class="holamundo adduser-popup"
      title="Add New Location"
      :active.sync="popupAddUser"
      @close="popupAddUser = true"
    >
      <attendee-add-edit
        v-if="popupAddUser"
        key="attendeeKey"
        :data_local="attendee_data"
        :locationList="locationList"
        :checkinRoleList="checkinRoleList"
        :designationList="designationList"
        @saveAttendeeSuccess="saveAttendeeSuccess"
        @cancelAddAttendee="cancelAddAttendee"
      />
      <!-- <div class="location-add-header">
        <h3>Add New User</h3>
        <vs-button radius color="#000" type="flat"
          ><feather-icon
            icon="XIcon"
            svgClasses="h-8 w-8"
            class=""
            @click="popupAddUser = false"
        /></vs-button>
      </div> -->
      <!-- <div class="vx-row">
        <div class="vx-col md:w-7/12 w-full mt-2 border-right-sec">
          <div class="checkin-add-form-location">
            <label>First Name*</label>
            <input type="text" name="" id="" placeholder="First Name" />

            <label>Last Name*</label>
            <input type="text" name="" id="" placeholder="Last Name" />

            <label>User Name*</label>
            <input type="text" name="" id="" placeholder="User Name" />

            <label>Email*</label>
            <vs-input
              autocomplete="off"
              class="w-full mt-4"
              v-model="data_local.Email"
              type="email"
              v-validate="'required|email'"
              name="Email"
              :readonly="emailFieldReadOnly"
            />
            <span class="text-danger text-sm" v-show="errors.has('Email')">{{
              errors.first("Email")
            }}</span>
            <label>Job Title </label>
            <input type="text" name="" id="" placeholder="Add Job Title" />
          </div>
        </div>
        <div class="vx-col md:w-5/12 w-full mt-2">
          <div class="location_image_upload">
            <div class="Location-image-area">
              <feather-icon
                icon="UserIcon"
                svgClasses="h-12 w-12"
                @click="popupActive = false"
              />
            </div>
            <h4>Drag &nbsp; drop or upload to add<br />user image</h4>
            <p>Image should be 1:1 ratio in JPG, PNG<br />Max file size 1MB</p>
            <div class="choosefile-button">
              <input type="file" />
              <p>Choose File</p>
            </div>
          </div>
        </div>
        <div class="vx-col md:w-6/12 w-full mt-2">
          <div class="checkin-add-form-location pr-0">
            <label>Assign Role</label>
            <v-select
              multiple
              :closeOnSelect="false"
              v-model="selected"
              :options="options"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
          </div>
        </div>
        <div class="vx-col md:w-6/12 w-full mt-2">
          <div class="checkin-add-form-location">
            <label>Select Location </label>
            <v-select
              multiple
              :closeOnSelect="false"
              v-model="selected2"
              :options="options"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
          </div>
        </div>
      </div> -->
    </vs-popup>
    <vs-popup
      class="location-added-popup"
      title="Inner popup"
      :active.sync="popupAddUserSuccess"
    >
      <div class="location-added-inner">
        <div class="location-add-successful-popup">
          <img src="../../assets/images/checkin-images/success-tick.png" />
        </div>
        <h2>{{ userSaveSuccessMsg }}</h2>
        <vs-button
          @click="popupAddUserSuccess = false"
          color="#00ccfe"
          type="filled"
          class="add-line-button"
          >GREAT</vs-button
        >
      </div>
    </vs-popup>

    <vs-popup
      class="holamundo adduser-popup"
      title="Lorem ipsum dolor sit amet"
      :active.sync="popupActiveRole"
    >
      <div class="user-popup">
        <vs-button
          @click="popupActiveRole = false"
          radius
          color="#000"
          type="flat"
          icon-pack="feather"
          icon="icon-x"
          class="close"
        ></vs-button>
        <role-listing @saveRoleSuccess="fetchCheckinRoles"></role-listing>
      </div>
    </vs-popup>

    <vs-popup
      class="holamundo adduser-popup"
      title="Lorem ipsum dolor sit amet"
      :active.sync="popupActiveDesignation"
    >
      <div class="user-popup">
        <vs-button
          @click="popupActiveDesignation = false"
          radius
          color="#000"
          type="flat"
          icon-pack="feather"
          icon="icon-x"
          class="close"
        ></vs-button>
        <designation-listing
          @saveDesignationSuccess="fetchDesignations"
        ></designation-listing>
      </div>
    </vs-popup>
  </div>
</template>
<script>
//import db from "@/firebase/firebaseInit.ts";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import moment from "moment-timezone";
import CKEditor from "ckeditor4-vue";
import CKconfig from "@/assets/ckeditor-config.ts";
import moduleEventManagement from "@/store/event-management/moduleEventManagement.js";
// Store Module
import moduleTicketManagement from "@/store/ticket-management/moduleTicketManagement.js";
import moduleAttendeeManagement from "@/store/attendee-management/moduleAttendeeManagement.js";
import moduleMailtplManagement from "@/store/mailtpl-management/moduleMailtplManagement.js";
import moduleCheckinLocationManagement from "@/store/checkin-location-management/moduleCheckinLocationManagement.js";
import moduleCheckinRoleManagement from "@/store/checkin-role-management/moduleCheckinRoleManagement.js";
import moduleDashboardManagement from "@/store/dashboard/moduleDashboard.js";
import ls from "@/common/localStorage";
import bu from "@/store/bulkupload/BulkUpload.js";
import con from "@/firebase/firebaseInit.ts";
// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererName from "./cell-renderer/CellRendererName.vue";
import CellRendererRole from "./cell-renderer/CellRendererRole.vue";
import CellRendererLocation from "./cell-renderer/CellRendererLocation.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import CellRendererHLActions from "./cell-renderer/CellRendererHLActions.vue";
import Swal from "sweetalert2";
import AttendeeSettings from "./AttendeeSettings.vue";
import FilterCriterias from "./FilterCriterias.vue";

import attendeeAddEdit from "./AttendeeAddEdit.vue";
import RoleListing from "./RoleListing.vue";
import DesignationListing from "./DesignationListing.vue";
import commonMixin from "@/mixins/common";

import { bus } from "../../main";

//console.log(db);
//const event_collectionName = 'sayek-dev';
var Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");

var vm;
export default {
  mixins: [commonMixin],
  components: {
    AgGridVue,
    vSelect,
    ckeditor: CKEditor.component,
    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererName,
    CellRendererRole,
    CellRendererLocation,
    CellRendererVerified,
    CellRendererActions,
    AttendeeSettings,
    FilterCriterias,
    CellRendererHLActions,
    attendeeAddEdit,
    RoleListing,
    DesignationListing,
  },
  data() {
    return {
      loggedInUserId: JSON.parse(ls.getSessionValueByKey("UserId")),
      con: con,
      rowHeight: 50,
      attendeeKey: 0,
      attendee_data: {},
      locationList: [],
      checkinRoleList: [],
      selectedRoles: [],
      designationList: [],
      paramLocationId: "",
      // enableCheckinModule: false,
      enableCheckinModule: JSON.parse(
        ls.getSessionValueByKey("UseOnlyGeoCheckinModule")
      ),
      userSaveSuccessMsg: "The new user has been successfully added.",
      popupAddUser: false,
      popupActiveRole: false,
      popupActiveDesignation: false,
      popupActiveAddNewRole: false,
      popupAddUserSuccess: false,
      editorConfig: CKconfig.editorConfig,
      Environment: con.Environment,
      selectedFilter: null,
      userData: [],
      EventData: [],
      attendeeData_duplicate: [],
      settingsData: { ShowMeetingButton: false },
      pageLoaded: false,

      popupActiveMailQR: false,
      popupActiveMail: false,
      previewSelectedTemplate: null,
      popupActiveMailUpdate: false,
      popupActiveRT: false,
      popupActiveRTF: false,
      RegistrationTypes: [],
      RegistrationTypeFilterVal: null,
      LoginTypeFilterVal: null,
      LoginFilterUsers: [],
      RegistrationTypeFilters: [],
      RegistrationTypeDetail: {
        RegistrationTypeId: null,
        RegistrationType: null,
        ColorCode: "#ffffff00",
      },
      mailRecepients: [],
      selectedMailPath: null,
      MailHtml: null,
      MailSubject: null,
      qrRecipients: null,
      // Filter Options
      roleFilter: { label: "All", value: "all" },
      roleOptions: [
        { label: "All", value: "all" },
        { label: "Admin", value: "admin" },
        { label: "User", value: "user" },
        { label: "Staff", value: "staff" },
      ],

      statusFilter: { label: "All", value: "all" },
      statusOptions: [
        { label: "All", value: "all" },
        { label: "Active", value: "active" },
        { label: "Deactivated", value: "deactivated" },
        { label: "Blocked", value: "blocked" },
      ],

      isVerifiedFilter: { label: "All", value: "all" },
      isVerifiedOptions: [
        { label: "All", value: "all" },
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" },
      ],

      departmentFilter: { label: "All", value: "all" },
      departmentOptions: [
        { label: "All", value: "all" },
        { label: "Sales", value: "sales" },
        { label: "Development", value: "development" },
        { label: "Management", value: "management" },
      ],

      searchQuery: "",
      popupActive: false,
      popupActive2: false,
      attendeeSettingsResetKey: 0,
      IsDefaultSettings: false,
      // AgGrid
      isselectPageRows: false,
      gridPageRows: 10,
      gridSelectedRows: 0,
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      checkinColumnDefs: [
        // {
        //   headerName: "ID",
        //   field: "AttendeeId",
        //   width: 50,
        //   filter: false,
        //   checkboxSelection: true,
        //   headerCheckboxSelectionFilteredOnly: true,
        //   headerCheckboxSelection: true,
        // },
        // {
        //   headerName: "First Name",
        //   field: "FirstName",
        //   filter: true,
        //   width: 200,
        //   //pinned: "left",
        // },
        // {
        //   headerName: "Last Name",
        //   field: "LastName",
        //   filter: true,
        //   width: 200,
        //   //pinned: "left",
        // },
        {
          headerName: "Name",
          field: "Name",
          filter: true,
          width: 300,
          unSortIcon: true,
          cellRendererFramework: "CellRendererName",
          cellRendererParams: (params) => {
            return {
              Name: params.data.Name,
              Email: params.data.Email,
              ProfilePictureURL: params.data.ProfilePictureURL,
              AttendeeId: params.data.AttendeeId,
            };
          },
        },
        {
          headerName: "Access Type",
          field: "RegistrationType.RegistrationType",
          filter: true,
          width: 150,
          unSortIcon: true,
        },
        {
          headerName: "Job Title",
          field: "Designation",
          filter: true,
          width: 150,
          unSortIcon: true,
        },
        {
          headerName: "Domain Area",
          field: "DomainArea",
          filter: true,
          width: 150,
          unSortIcon: true,
        },
        {
          headerName: "Role",
          // field: "Role",
          filter: false,
          width: 150,
          cellRendererFramework: "CellRendererRole",
          cellRendererParams: (params) => {
            return {
              CheckinRoles: params.data.CheckinRoles,
              checkinRoleList: this.checkinRoleList,
            };
          },
        },
        {
          headerName: "Location",
          // field: "Location",
          filter: false,
          width: 200,
          cellRendererFramework: "CellRendererLocation",
          cellRendererParams: (params) => {
            return {
              MappedLocations: params.data.MappedLocations,
              locationList: this.locationList,
            };
          },
        },
        {
          headerName: "Base Lab",
          field: "BaseLab",
          filter: true,
          width: 200,
          unSortIcon: true,
        },

        // {
        //   headerName: "Status",
        //   field: "transactions",
        //   filter: true,
        //   width: 150,
        //   cellRendererFramework: "CellRendererStatus",
        //   cellRendererParams: (params) => {
        //     return {
        //       id: params.data.AttendeeId,
        //       Email: params.data.Email,
        //       DynamicFields: params.data.DynamicFields,
        //     };
        //   },
        // },
        {
          headerName: "Actions",
          field: "transactions",
          width: this.enableCheckinModule ? 120 : 100,
          cellRendererFramework: "CellRendererActions",
          sortable: false,
          cellRendererParams: (params) => {
            return {
              id: params.data.AttendeeId,
              Email: params.data.Email,
              FirstName: params.data.FirstName,
              LastName: params.data.LastName,
              DynamicFields: params.data.DynamicFields,
              QR: params.data.VCard ? params.data.VCard.QR : null,
            };
          },
          pinned: "right",
        },
      ],
      columnDefs: [
        {
          headerName: "ID",
          field: "AttendeeId",
          width: 50,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
        },
        {
          headerName: "First Name",
          field: "FirstName",
          filter: true,
          width: 200,
          //pinned: "left",
        },
        {
          headerName: "Last Name",
          field: "LastName",
          filter: true,
          width: 200,
          //pinned: "left",
        },
        {
          headerName: "Email",
          field: "Email",
          filter: true,
          width: 200,
        },
        {
          headerName: "Country",
          field: "Country",
          filter: true,
          width: 150,
        },
        {
          headerName: "Company",
          field: "Company",
          filter: true,
          width: 150,
        },
        {
          headerName: "Title",
          field: "Designation",
          filter: true,
          width: 150,
        },
        {
          headerName: "Status",
          field: "transactions",
          filter: true,
          width: 150,
          cellRendererFramework: "CellRendererStatus",
          cellRendererParams: (params) => {
            return {
              id: params.data.AttendeeId,
              Email: params.data.Email,
              DynamicFields: params.data.DynamicFields,
            };
          },
        },
        {
          headerName: "Created On",
          field: "CreatedDate",
          cellRenderer: (data) => {
            return data.value
              ? this.SetTimeByZone(
                  new Date(data.value.seconds * 1000).toUTCString(),
                  Session_Event_TZ
                )
              : "";
          },
          filter: true,
          width: 150,
        },
        /*{
          headerName: "Attendee Type",
          field: "FormType",
          filter: true,
          width: 300,
        },*/
        {
          headerName: "Registration Type",
          field: "RegistrationType",
          filter: true,
          cellRenderer: (data) => {
            if (typeof data.value == "object")
              return data.value.RegistrationType;
            else return data.value;
          },
        },
        {
          headerName: "RSVP Code",
          field: "RSVPCode",
          filter: true,
          width: 300,
        },
        {
          headerName: "Hide from list",
          field: "transactions",
          cellRendererFramework: "CellRendererHLActions",
          width: 100,
          cellRendererParams: (params) => {
            return { id: params.data.AttendeeId };
          },
        },
        {
          headerName: "Actions",
          field: "transactions",
          width: 120,
          cellRendererFramework: "CellRendererActions",
          cellRendererParams: (params) => {
            return {
              id: params.data.AttendeeId,
              Email: params.data.Email,
              FirstName: params.data.FirstName,
              LastName: params.data.LastName,
              DynamicFields: params.data.DynamicFields,
              QR: params.data.VCard ? params.data.VCard.QR : null,
            };
          },
          pinned: "right",
        },
      ],
      popupFilterCriteria: false,
      filterCriteriaKey: 0,
      prevRoute: null,

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererName,
        CellRendererRole,
        CellRendererLocation,
        CellRendererVerified,
        CellRendererActions,
        CellRendererHLActions,
      },
    };
  },
  watch: {
    /*roleFilter (obj) {
      this.setColumnFilter('role', obj.value)
    },
    statusFilter (obj) {
      this.setColumnFilter('status', obj.value)
    },
    isVerifiedFilter (obj) {
      const val = obj.value === 'all' ? 'all' : obj.value === 'yes' ? 'true' : 'false'
      this.setColumnFilter('is_verified', val)
    },
    departmentFilter (obj) {
      this.setColumnFilter('department', obj.value)
    }*/
    // previewSelectedTemplate: function () {
    //   this.setPreviewMailTemplate();
    // },
    LoginTypeFilterVal(val) {
      this.RegistrationTypeFilterVal = null;
      this.getLoginFilterUsers();
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },
  computed: {
    // selectedRoles() {},
    attendeeData() {
      this.userData = this.$store.state.attendeeManagement.attendees;
      let filterData = this.$store.state.attendeeManagement.attendees;
      let allAttendees = this.$store.state.attendeeManagement.attendees;
      if (!this.enableCheckinModule) {
        if (this.LoginFilterUsers.length) {
          filterData = allAttendees.filter((item) => {
            let found = this.LoginFilterUsers.some(
              (fitem) => fitem.id == item.AttendeeId
            );
            if (found) return item;
          });
        }
        if (this.RegistrationTypeFilterVal) {
          filterData = filterData.filter((item) => {
            if (
              item.RegistrationType &&
              typeof item.RegistrationType == "string" &&
              item.RegistrationType == this.RegistrationTypeFilterVal
            )
              return item;
            else if (
              item.RegistrationType &&
              item.RegistrationType.RegistrationType ==
                this.RegistrationTypeFilterVal
            )
              return item;
          });
        }
        return filterData;
      } else {
        if (this.selectedRoles && this.selectedRoles.length > 0) {
          filterData = filterData.filter((item) => {
            if (
              item.CheckinRoles &&
              item.CheckinRoles.includes(this.selectedRoles)
            ) {
              return true;
            }
          });
        }
        if (vm.paramLocationId) {
          filterData = filterData.filter((item) => {
            if (
              item.MappedLocations &&
              item.MappedLocations.includes(vm.paramLocationId)
            ) {
              return true;
            }
          });
        }
        return filterData;
      }
    },
    urlLocationData() {
      var result;
      if (this.paramLocationId && this.locationList.length > 0) {
        result = this.locationList.filter((item) => {
          if (item.LocationId == this.paramLocationId) {
            return true;
          }
        });
      }
      return result;
    },
    /*usersData () {
      return this.$store.state.userManagement.users
    },*/
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
    mailtplData() {
      if (this.Environment != "EDU")
        return this.$store.state.mailtplManagement.mailtpls.filter((item) =>
          ["AnnouncementMail", "ReminderMail", "Custom"].includes(
            item.CollectionName
          )
        );
      else
        return this.$store.state.mailtplManagement.mailtpls.filter((item) =>
          ["ReminderMail"].includes(item.CollectionName)
        );
    },
  },
  methods: {
    // iconClick(){
    //   alert("icon click");
    // },
    fetchCheckinRoles() {
      debugger;
      this.$store
        .dispatch("checkinRoleManagement/fetchGeoCheckinRoles")
        .then((res) => {
          debugger;
          vm.checkinRoleList = [];

          res.data[0].map(function (item) {
            if (item.IsPublished) {
              vm.checkinRoleList.push({
                RoleId: item.RoleId,
                Name: item.Name,
                Color: item.Color,
                ImageUrl: item.ImageUrl,
                IsDefault: false,
                Primary: "Make It Primary",
              });
            }
          });
          //vm.checkinRoleList = res.data[0];
        });
    },
    exportSelectedForGeoCheckin() {
      this.selectedFilter = null;
      this.attendeeData_duplicate = [];
      let mainFields = ["FirstName", "LastName", "Email", "Designation"];
      let selectedRows;

      selectedRows = this.gridApi.selectAll();
      selectedRows = this.gridApi.getSelectedRows();

      //console.log(selectedRows);
      if (selectedRows.length > 0) {
        this.popupActiveExport = true;
        var datarow = [];
        var datarowh = [];
        let cellIndex = [];
        let DynamicFieldsIndex = 4;
        let DynamicFieldsStartIndex = 4;

        //datarowh.push("Name");
        datarowh.push("First Name");
        datarowh.push("Last Name");
        datarowh.push("User Name");
        // datarowh.push("Email");

        datarowh.push("Title/Designation");
        datarowh.push("Domain Area");
        datarowh.push("Base Lab");

        datarowh.push("Roles");
        datarowh.push("Location");

        datarowh.push("Status");
        datarowh.push("Created Date");
        datarowh.push("User Id");
        var AttendeeData = [];
        let Header = [];
        let Data = [];
        var TimeZoneHeader = [];
        let Header1 = [];

        selectedRows.filter((row) => {
          if (row.DynamicFields) {
            if (Array.isArray(row.DynamicFields)) {
              row.DynamicFields.filter(function (rowfeild) {
                if (rowfeild.Label) {
                  let Label = rowfeild.Label.replace(",", "-");
                  if (!datarowh.includes(Label)) {
                    cellIndex.push({
                      index: DynamicFieldsIndex,
                      Label: Label,
                      Value: rowfeild.Value,
                    });
                    datarowh.push(Label);
                    DynamicFieldsIndex++;
                  }
                }
              });
            } else if (typeof row.DynamicFields == "object") {
              let DynamicFields = Object.values(row.DynamicFields);
              DynamicFields.filter(function (rowfeild) {
                if (rowfeild.label) {
                  let label = rowfeild.label.replace(",", "-");
                  if (!datarowh.includes(label)) {
                    cellIndex.push({
                      index: DynamicFieldsIndex,
                      label: label,
                      value: rowfeild.value,
                    });
                    datarowh.push(label);
                    DynamicFieldsIndex++;
                  }
                }
              });
            }
          }
        });

        let DefaultFieldsHeader = [];
        selectedRows.filter((row) => {
          if (row.DefaultFields && row.DefaultFields.length) {
            for (let df of row.DefaultFields) {
              if (
                df.Label &&
                !mainFields.includes(df.Name) &&
                !DefaultFieldsHeader.includes(df.Label)
              ) {
                datarowh.push(`"${df.Label}"`);
                DefaultFieldsHeader.push(df.Label);
              }
            }
          }
        });

        selectedRows.map((row) => {
          console.log("rows-----", row);

          //---------------------------------------------------------
          let datarowv = [];

          /*var name = "";
          name = row.Name == undefined ? "" : row.Name;
          datarowv.push(name);*/
          var FirstName = "";
          FirstName = row.FirstName == undefined ? "" : row.FirstName;
          datarowv.push(
            '"' +
              FirstName.replace("#", "")
                .replace("#", "")
                .replace("#", "")
                .replace("#", "")
                .replace("#", "") +
              '"'
          );

          var LastName = "";
          LastName = row.LastName == undefined ? "" : row.LastName;
          datarowv.push(
            '"' +
              LastName.replace("#", "")
                .replace("#", "")
                .replace("#", "")
                .replace("#", "")
                .replace("#", "") +
              '"'
          );

          var UserName = "";
          UserName = row.Username == undefined ? "" : row.Username;
          datarowv.push(
            '"' +
              UserName.replace("#", "")
                .replace("#", "")
                .replace("#", "")
                .replace("#", "")
                .replace("#", "") +
              '"'
          );

          // var Email = "";
          // Email = row.Email == undefined ? "" : row.Email;
          // datarowv.push(
          //   '"' +
          //     Email.replace("#", "")
          //       .replace("#", "")
          //       .replace("#", "")
          //       .replace("#", "") +
          //     '"'
          // );

          var Designation = "";
          var Designation = row.Designation == undefined ? "" : row.Designation;
          datarowv.push(
            '"' +
              Designation.replace("#", "").replace("#", "").replace("#", "") +
              '"'
          );

          var DomainArea = "";
          DomainArea = row.DomainArea == undefined ? "" : row.DomainArea;
          datarowv.push(
            '"' +
              DomainArea.replace("#", "").replace("#", "").replace("#", "") +
              '"'
          );

          var BaseLab = "";
          BaseLab = row.BaseLab == undefined ? "" : row.BaseLab;
          datarowv.push(
            '"' +
              BaseLab.replace("#", "").replace("#", "").replace("#", "") +
              '"'
          );

          //checkinRoles

          if (row.CheckinRoles && row.CheckinRoles.length > 0) {
            let CheckinRolesResult = "";
            vm.checkinRoleList.map((item, index) => {
              if (row.CheckinRoles.includes(item.RoleId)) {
                if (row.CheckinRoles.length == 1) {
                  CheckinRolesResult += item.Name;
                } else {
                  if (index !== vm.checkinRoleList.length - 1) {
                    CheckinRolesResult += item.Name;
                    CheckinRolesResult += ", ";
                  } else {
                    CheckinRolesResult += item.Name;
                  }
                }
              }
            });

            datarowv.push('"' + CheckinRolesResult + '"');
          } else {
            datarowv.push('"' + "" + '"');
          }

          //Checkin Location

          if (row.MappedLocations && row.MappedLocations.length > 0) {
            let CheckinLocationsResult = "";
            vm.locationList.map((item, index) => {
              if (row.MappedLocations.includes(item.LocationId)) {
                if (row.MappedLocations.length == 1) {
                  CheckinLocationsResult += item.Name;
                } else {
                  if (index !== vm.locationList.length - 1) {
                    CheckinLocationsResult += item.Name;
                    CheckinLocationsResult += ", ";
                  } else {
                    CheckinLocationsResult += item.Name;
                  }
                }
              }
            });

            datarowv.push('"' + CheckinLocationsResult + '"');
          } else {
            datarowv.push('"' + "" + '"');
          }

          var Status = "";
          Status = row.IsPublished ? "Active" : "Inactive";
          datarowv.push(Status);

          var CreatedDate = "";
          CreatedDate =
            row.CreatedDate == undefined
              ? ""
              : this.SetTimeByZone(
                  new Date(row.CreatedDate.seconds * 1000).toUTCString(),
                  this.EventData.TimeZone
                );
          datarowv.push('"' + CreatedDate + '"');

          var attendeeId = "";
          attendeeId = row.AttendeeId == undefined ? "" : row.AttendeeId;
          datarowv.push('"' + attendeeId + '"');

          if (row.DefaultFields && row.DefaultFields.length) {
            for (let df of row.DefaultFields) {
              if (df.Label && !mainFields.includes(df.Name)) {
                if (Array.isArray(df.value))
                  datarowv.push(`"${df.value.toString()}"`);
                else datarowv.push(`"${df.value}"`);
              }
            }
          }
          //----------------------------------------------------------------------------------
          let cellval = DynamicFieldsStartIndex;
          if (row.DynamicFields) {
            if (Array.isArray(row.DynamicFields)) {
              cellIndex.filter(function (cellfeild) {
                let cellvalue = "";
                row.DynamicFields.filter((rowf) => {
                  if (
                    rowf.Label.replace(/[, ]+/g, "") ==
                    cellfeild.Label.replace(/[, ]+/g, "")
                  ) {
                    if (Array.isArray(rowf.Value)) {
                      let arr = rowf.Value.map(function (s) {
                        return s.replace(/[, ]+/g, "").replace(/#(\S)/g, " ");
                      });

                      cellvalue = arr.join("|");
                    } else {
                      cellvalue = rowf.Value.replace(/#(\S)/g, " ");
                    }
                  }
                });
                datarowv.push(cellvalue.replace(/[/ ]+/g, " "));
                cellval++;
              });
            } else if (typeof row.DynamicFields == "object") {
              let DynamicFields = Object.values(row.DynamicFields);
              cellIndex.filter(function (cellfeild) {
                let cellvalue = "";
                DynamicFields.filter((rowf) => {
                  if (
                    rowf.label.replace(/[, ]+/g, "") ==
                    cellfeild.label.replace(/[, ]+/g, "")
                  ) {
                    if (Array.isArray(rowf.value)) {
                      let arr = rowf.value.map(function (s) {
                        return s.replace(/[, ]+/g, "").replace(/#(\S)/g, " ");
                      });

                      cellvalue = arr.join("|");
                    } else {
                      cellvalue = rowf.value.replace(/#(\S)/g, " ");
                    }
                  }
                });
                datarowv.push(cellvalue.replace(/[/ ]+/g, " "));
                cellval++;
              });
            }
          }
          Data.push(datarowv);

          //---------------------------------------------------------
        });
        Header1.push(datarow);
        Header.push(datarowh);
        debugger;
        let csvContent = "data:text/csv;charset=utf-8,";
        var dt = new Date().toISOString().slice(0, 10);
        TimeZoneHeader = Header1;
        AttendeeData = Header.concat(Data);
        TimeZoneHeader.forEach(function (rowArray) {
          let row = rowArray.join(",");
          csvContent += row + "\r\n";
        });
        debugger;
        AttendeeData.forEach(function (rowArray) {
          let row = rowArray.join(",");
          csvContent += row + "\r\n";
        });

        var filename = "UserExport_" + "_" + dt + ".csv";

        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        //link.setAttribute("id", "Participance_RT_" + row.TableId);
        link.setAttribute("download", filename);
        document.body.appendChild(link); // Required for FF

        link.click();

        this.gridApi.deselectAll();

        //---------------------------------------------------------------
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Download Reports",
          text: "Please select atleast one attendee to download. ",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    selectPageRows() {
      let start = (this.currentPage - 1) * this.gridPageRows;
      if (this.isselectPageRows) {
        for (let i = 0; i < this.gridPageRows; i++) {
          if (this.isselectPageRows)
            this.gridApi.getDisplayedRowAtIndex(start).setSelected(true);
          else this.gridApi.getDisplayedRowAtIndex(start).setSelected(false);
          start++;
        }
        start = 0;
      } else {
        this.gridApi.deselectAll();
      }
    },
    onSelectionChanged() {
      let selectedRows = this.gridApi.getSelectedRows();
      this.gridSelectedRows = selectedRows.length;
    },
    SetTimeByZone: function (strDateTime, timeZone) {
      var date = moment
        .tz(strDateTime, timeZone)
        .format("MMM DD, YYYY hh:mm A");
      return date;
    },
    getDefaultSettings() {
      if (!this.settingsData.DefaultSettingsLoaded) {
        this.IsDefaultSettings = true;
        this.settingsData = {
          AttendeeListSortBy: "FirstName",
          EnableAttendeeDBsearch: true,
          ShowEmailandPhone: true,
          ShowFilter: true,
          ShowLegend: false,
          ShowMeetingButton: true,
          ShowSearch: true,
          ShowSendMessageButton: true,
        };
      }
      this.attendeeSettingsResetKey += 1;
      this.popupActive2 = true;
    },
    getSettings() {
      this.attendeeSettingsResetKey += 1;
      this.popupActive2 = true;
    },
    copySpeaker() {
      this.selectedFilter = null;
      this.attendeeData_duplicate = [];
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      //console.log(selectedRows);
      if (selectedRows.length > 0) {
        this.$vs.loading();
        this.$store
          .dispatch("attendeeManagement/copySpeakerFromAttendee", selectedRows)
          .then((res) => {
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Create Speaker",
              text: res.message,
            });
            this.$vs.loading.close();
          });
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Create Speaker",
          text: "Please select atleast one attendee to create speaker. ",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },

    NotificationReport() {
      this.selectedFilter = null;
      this.attendeeData_duplicate = [];
      this.$vs.loading();
      var cn = ls.getSessionEventCollectionName();
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      //console.log(selectedRows);
      if (selectedRows.length > 0) {
        var datarow = [];
        var datarowh = [];
        datarowh.push("NotificationID");
        datarowh.push("Name");
        datarowh.push("Email");
        datarowh.push("NotificationTitle");
        datarowh.push("NotificationMessage");
        datarowh.push("CreatedDate");
        datarowh.push("SeenTime");
        let Data = [];
        let Header = [];
        selectedRows.map((row) => {
          con.eventDB
            .collection(cn)
            .doc("AttendeeList")
            .collection("Attendees")
            .doc(row.AttendeeId)
            .collection("Notifications")
            .get()
            .then((querySnapshot) => {
              var notificationData = [];
              querySnapshot.forEach((doc) => {
                let datarowv = [];
                var objDoc = doc.data();
                if (objDoc.Module == "Notification") {
                  debugger;
                  var obj = new Object();

                  //   obj.notificationId = doc.id;
                  datarowv.push(doc.id);
                  //obj.Name = objDoc.Name != undefined ? objDoc.Name : "";
                  datarowv.push(objDoc.Name);
                  //     obj.Email = row.Email != undefined ? row.Email : "";

                  datarowv.push(row.Email);

                  // obj.NotificationTitle =
                  //   objDoc.NotificationTitle != undefined
                  //     ? objDoc.NotificationTitle.replace(",", "")
                  //         .replace(",", "")
                  //         .replace(",", "")
                  //         .replace(",", "")
                  //     : "";

                  datarowv.push(
                    objDoc.NotificationTitle != undefined
                      ? objDoc.NotificationTitle.replace(",", "")
                          .replace(",", "")
                          .replace(",", "")
                          .replace(",", "")
                      : ""
                  );

                  // obj.NotificationMessage =
                  //   objDoc.NotificationMessage != undefined
                  //     ? objDoc.NotificationMessage.replace(",", "")
                  //         .replace(",", "")
                  //         .replace(",", "")
                  //         .replace(",", "")
                  //     : "";

                  datarowv.push(
                    objDoc.NotificationMessage != undefined
                      ? objDoc.NotificationMessage.replace(",", "")
                          .replace(",", "")
                          .replace(",", "")
                          .replace(",", "")
                      : ""
                  );

                  // obj.CreatedDate =
                  //   objDoc.CreatedDate != undefined
                  //     ? vm.SetTimeByZone(
                  //         new Date(
                  //           objDoc.CreatedDate.seconds * 1000
                  //         ).toUTCString(),
                  //         vm.EventData.TimeZone
                  //       )
                  //     : "";

                  datarowv.push(
                    objDoc.CreatedDate != undefined
                      ? vm.SetTimeByZone(
                          new Date(
                            objDoc.CreatedDate.seconds * 1000
                          ).toUTCString(),
                          vm.EventData.TimeZone
                        )
                      : ""
                  );

                  // obj.SeenTime =
                  //   objDoc.SeenTime != undefined
                  //     ? vm.SetTimeByZone(
                  //         new Date(
                  //           objDoc.SeenTime.seconds * 1000
                  //         ).toUTCString(),
                  //         vm.EventData.TimeZone
                  //       )
                  //     : "";

                  datarowv.push(
                    objDoc.SeenTime != undefined
                      ? vm.SetTimeByZone(
                          new Date(
                            objDoc.SeenTime.seconds * 1000
                          ).toUTCString(),
                          vm.EventData.TimeZone
                        )
                      : ""
                  );
                }
                debugger;
                Data.push(datarowv);
              });
              this.$vs.loading.close();
              console.log(Data);
              Header.push(datarowh);
              //+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
              notificationData = Header.concat(Data);
              debugger;
              let csvContent = "data:text/csv;charset=utf-8,";
              notificationData.forEach(function (rowArray) {
                let row = rowArray.join(",");
                csvContent += row + "\r\n";
              });
              var dt = new Date().toISOString().slice(0, 10);
              var filename =
                "AttendeeNotificationReport_" +
                row.AttendeeId +
                "_" +
                dt +
                ".csv";
              var encodedUri = encodeURI(csvContent);
              var link = document.createElement("a");
              link.setAttribute("href", encodedUri);
              link.setAttribute("download", filename);

              document.body.appendChild(link); // Required for FF
              link.click();
              //++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
            })
            .catch((err) => {
              this.$vs.loading.close();
              debugger;
              console.error(err);
            });
        });
      }
    },
    fetch_event_data() {
      let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
      this.$store
        .dispatch("eventManagement/fetchEvent", Session_Event_Id)
        .then((res) => {
          vm.EventData = res.data;
        });
    },
    exportSelected() {
      this.selectedFilter = null;
      this.attendeeData_duplicate = [];
      let mainFields = [
        "FirstName",
        "LastName",
        "Email",
        "Phone",
        "Company",
        "Designation",
        "Country",
        "State",
        "City",
        "ZIP",
      ];
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      //console.log(selectedRows);
      if (selectedRows.length > 0) {
        this.popupActiveExport = true;
        var datarow = [];
        var datarowh = [];
        let cellIndex = [];
        let DynamicFieldsIndex = 4;
        let DynamicFieldsStartIndex = 4;
        datarow.push("Report Exported In ");
        var timezone = Session_Event_TZ == undefined ? "" : Session_Event_TZ;
        datarow.push('"' + timezone + " Time Zone" + '"');
        datarowh.push("Salutation");
        //datarowh.push("Name");
        datarowh.push("First Name");
        datarowh.push("Last Name");
        datarowh.push("Email");
        datarowh.push("Phone");
        datarowh.push("Company");
        datarowh.push("Title/Designation");
        datarowh.push("MailingAddress");
        datarowh.push("Country");
        datarowh.push("State");
        datarowh.push("City");
        datarowh.push("ZIP");
        datarowh.push("RegistrationType");
        datarowh.push("RSVPCode");
        datarowh.push("Status");
        datarowh.push("Created Date");
        datarowh.push("Attendee Id");
        var AttendeeData = [];
        let Header = [];
        let Data = [];
        var TimeZoneHeader = [];
        let Header1 = [];

        selectedRows.filter((row) => {
          if (row.DynamicFields) {
            if (Array.isArray(row.DynamicFields)) {
              row.DynamicFields.filter(function (rowfeild) {
                if (rowfeild.Label) {
                  let Label = rowfeild.Label.replace(",", "-");
                  if (!datarowh.includes(Label)) {
                    cellIndex.push({
                      index: DynamicFieldsIndex,
                      Label: Label,
                      Value: rowfeild.Value,
                    });
                    datarowh.push(Label);
                    DynamicFieldsIndex++;
                  }
                }
              });
            } else if (typeof row.DynamicFields == "object") {
              let DynamicFields = Object.values(row.DynamicFields);
              DynamicFields.filter(function (rowfeild) {
                if (rowfeild.label) {
                  let label = rowfeild.label.replace(",", "-");
                  if (!datarowh.includes(label)) {
                    cellIndex.push({
                      index: DynamicFieldsIndex,
                      label: label,
                      value: rowfeild.value,
                    });
                    datarowh.push(label);
                    DynamicFieldsIndex++;
                  }
                }
              });
            }
          }
        });

        let DefaultFieldsHeader = [];
        selectedRows.filter((row) => {
          if (row.DefaultFields && row.DefaultFields.length) {
            for (let df of row.DefaultFields) {
              if (
                df.Label &&
                !mainFields.includes(df.Name) &&
                !DefaultFieldsHeader.includes(df.Label)
              ) {
                datarowh.push(`"${df.Label}"`);
                DefaultFieldsHeader.push(df.Label);
              }
            }
          }
        });

        selectedRows.map((row) => {
          //---------------------------------------------------------
          let datarowv = [];

          var salutation = "";
          salutation = row.Salutation == undefined ? "" : row.Salutation;
          datarowv.push(salutation);

          /*var name = "";
          name = row.Name == undefined ? "" : row.Name;
          datarowv.push(name);*/
          var FirstName = "";
          FirstName = row.FirstName == undefined ? "" : row.FirstName;
          datarowv.push(
            '"' +
              FirstName.replace("#", "")
                .replace("#", "")
                .replace("#", "")
                .replace("#", "")
                .replace("#", "") +
              '"'
          );

          var LastName = "";
          LastName = row.LastName == undefined ? "" : row.LastName;
          datarowv.push(
            '"' +
              LastName.replace("#", "")
                .replace("#", "")
                .replace("#", "")
                .replace("#", "")
                .replace("#", "") +
              '"'
          );

          var Email = "";
          Email = row.Email == undefined ? "" : row.Email;
          datarowv.push(
            '"' +
              Email.replace("#", "")
                .replace("#", "")
                .replace("#", "")
                .replace("#", "") +
              '"'
          );

          var Phone = "";
          Phone = row.Phone == undefined ? "" : row.Phone;
          datarowv.push('"' + Phone + '"');

          var Company = "";
          Company = row.Company == undefined ? "" : row.Company;
          Company.replace("#", "");
          datarowv.push('"' + Company.replace("#", "").replace("#", "") + '"');

          var Designation = "";
          var Designation = row.Designation == undefined ? "" : row.Designation;
          datarowv.push(
            '"' +
              Designation.replace("#", "").replace("#", "").replace("#", "") +
              '"'
          );

          var MailingAddress = "";
          MailingAddress =
            row.MailingAddress == undefined ? "" : row.MailingAddress;
          datarowv.push(
            '"' +
              MailingAddress.replace("#", "")
                .replace("#", "")
                .replace("#", "")
                .replace("#", "")
                .replace("#", "") +
              '"'
          );

          var Country = "";
          Country = row.Country == undefined ? "" : row.Country;
          datarowv.push(Country);

          var State = "";
          State = row.State == undefined ? "" : row.State;
          datarowv.push('"' + State + '"');

          var City = "";
          City = row.City == undefined ? "" : row.City;
          datarowv.push(
            '"' +
              City.replace("#", "")
                .replace("#", "")
                .replace("#", "")
                .replace("#", "")
                .replace("#", "") +
              '"'
          );

          var Zip = "";
          Zip = row.Zip == undefined ? "" : row.Zip;
          datarowv.push(
            '"' +
              Zip.replace("#", "")
                .replace("#", "")
                .replace("#", "")
                .replace("#", "")
                .replace("#", "") +
              '"'
          );

          var RegistrationType = "";
          RegistrationType =
            row.RegistrationType == undefined ? "" : row.RegistrationType;
          if (typeof RegistrationType == "object")
            RegistrationType = RegistrationType.RegistrationType;

          datarowv.push('"' + RegistrationType + '"');

          var RSVPCode = "";
          RSVPCode = row.RSVPCode == undefined ? "" : row.RSVPCode;
          datarowv.push('"' + RSVPCode + '"');

          var Status = "";
          Status = row.IsPublished ? "Active" : "Inactive";
          datarowv.push(Status);

          var CreatedDate = "";
          CreatedDate =
            row.CreatedDate == undefined
              ? ""
              : this.SetTimeByZone(
                  new Date(row.CreatedDate.seconds * 1000).toUTCString(),
                  this.EventData.TimeZone
                );
          datarowv.push('"' + CreatedDate + '"');

          var attendeeId = "";
          attendeeId = row.AttendeeId == undefined ? "" : row.AttendeeId;
          datarowv.push('"' + attendeeId + '"');

          if (row.DefaultFields && row.DefaultFields.length) {
            for (let df of row.DefaultFields) {
              if (df.Label && !mainFields.includes(df.Name)) {
                if (Array.isArray(df.value))
                  datarowv.push(`"${df.value.toString()}"`);
                else datarowv.push(`"${df.value}"`);
              }
            }
          }
          //----------------------------------------------------------------------------------
          let cellval = DynamicFieldsStartIndex;
          if (row.DynamicFields) {
            if (Array.isArray(row.DynamicFields)) {
              cellIndex.filter(function (cellfeild) {
                let cellvalue = "";
                row.DynamicFields.filter((rowf) => {
                  if (
                    rowf.Label.replace(/[, ]+/g, "") ==
                    cellfeild.Label.replace(/[, ]+/g, "")
                  ) {
                    if (Array.isArray(rowf.Value)) {
                      let arr = rowf.Value.map(function (s) {
                        return s.replace(/[, ]+/g, "").replace(/#(\S)/g, " ");
                      });

                      cellvalue = arr.join("|");
                    } else {
                      cellvalue = rowf.Value.replace(/#(\S)/g, " ");
                    }
                  }
                });
                datarowv.push(cellvalue.replace(/[/ ]+/g, " "));
                cellval++;
              });
            } else if (typeof row.DynamicFields == "object") {
              let DynamicFields = Object.values(row.DynamicFields);
              cellIndex.filter(function (cellfeild) {
                let cellvalue = "";
                DynamicFields.filter((rowf) => {
                  if (
                    rowf.label.replace(/[, ]+/g, "") ==
                    cellfeild.label.replace(/[, ]+/g, "")
                  ) {
                    if (Array.isArray(rowf.value)) {
                      let arr = rowf.value.map(function (s) {
                        return s.replace(/[, ]+/g, "").replace(/#(\S)/g, " ");
                      });

                      cellvalue = arr.join("|");
                    } else {
                      cellvalue = rowf.value.replace(/#(\S)/g, " ");
                    }
                  }
                });
                datarowv.push(cellvalue.replace(/[/ ]+/g, " "));
                cellval++;
              });
            }
          }
          Data.push(datarowv);

          //---------------------------------------------------------
        });
        Header1.push(datarow);
        Header.push(datarowh);
        debugger;
        let csvContent = "data:text/csv;charset=utf-8,";
        var dt = new Date().toISOString().slice(0, 10);
        TimeZoneHeader = Header1;
        AttendeeData = Header.concat(Data);
        TimeZoneHeader.forEach(function (rowArray) {
          let row = rowArray.join(",");
          csvContent += row + "\r\n";
        });
        debugger;
        AttendeeData.forEach(function (rowArray) {
          let row = rowArray.join(",");
          csvContent += row + "\r\n";
        });
        var filename = "AttendeeExport_" + "_" + dt + ".csv";
        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        //link.setAttribute("id", "Participance_RT_" + row.TableId);
        link.setAttribute("download", filename);
        document.body.appendChild(link); // Required for FF

        link.click();
        //---------------------------------------------------------------
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Download Reports",
          text: "Please select atleast one attendee to download. ",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    saveSettings() {
      this.$vs.loading();
      this.$store
        .dispatch("attendeeManagement/saveSettings", {
          settingsData: this.settingsData,
          IsDefaultSettings: this.IsDefaultSettings,
        })
        .then((res) => {
          this.popupActive2 = false;
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Settings",
            text: res.message,
          });
          this.IsDefaultSettings = false;
          this.$vs.loading.close();
        });
    },
    async getMailTpls(val) {
      this.$vs.loading();
      this.MailHtml = null;
      this.MailSubject = null;
      this.selectedMailPath = null;
      await this.$store.dispatch("mailtplManagement/fetchMailtpls");
      if (val == "QR") this.popupActiveMailQR = true;
      else this.popupActiveMail = true;
      this.$vs.loading.close();
    },
    getMailTpl() {
      this.$vs.loading();
      this.MailHtml = "Loading...";
      this.$store
        .dispatch("attendeeManagement/getMailTemplate", this.selectedMailPath)
        .then((res) => {
          this.MailHtml = res.html;
          this.MailSubject = res.subject;
          this.$vs.loading.close();
        });
    },
    saveRegistrationType() {
      vm.$vs.loading();
      let RegistrationTypeId = vm.RegistrationTypeDetail.RegistrationTypeId;
      if (RegistrationTypeId) {
        this.$store
          .dispatch("TicketManagement/updateRegistrationTypeNameColorCode", {
            data: {
              RegistrationType: vm.RegistrationTypeDetail.RegistrationType,
              ColorCode: vm.RegistrationTypeDetail.ColorCode,
            },
            RegistrationTypeId: RegistrationTypeId,
          })
          .then((res) => {
            vm.popupActiveRT = false;
            vm.popupActiveRTF = false;
            vm.$vs.loading.close();
            this.$vs.notify({
              color: res.status == 200 ? "success" : "warning",
              position: "top-center",
              text: res.message,
            });
          });
      }
    },
    addRegistrationType() {
      vm.popupActiveRT = false;
      vm.popupActiveRTF = true;
      this.RegistrationTypeDetail = {
        RegistrationTypeId: null,
        RegistrationType: null,
        ColorCode: "#ffffff00",
      };
    },
    editRegistrationType(valObj) {
      vm.popupActiveRT = false;
      vm.popupActiveRTF = true;
      this.RegistrationTypeDetail = valObj;
    },
    registrationTypes() {
      vm.$vs.loading();
      vm.$store
        .dispatch("TicketManagement/fetchRegistrationTypes")
        .then((res) => {
          vm.RegistrationTypes = res;
          vm.popupActiveRT = true;
          vm.$vs.loading.close();
        });
    },
    getRegistrationTypeFilters() {
      vm.$store
        .dispatch("TicketManagement/fetchRegistrationTypes")
        .then((res) => {
          vm.RegistrationTypeFilters = res.map((item) => {
            return item.RegistrationType;
          });
        });
    },
    getfilterCriterias() {
      vm.popupFilterCriteria = true;
      vm.filterCriteriaKey += 1;
    },
    changeStatus(Status) {
      this.selectedFilter = null;
      this.attendeeData_duplicate = [];
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      if (selectedRows.length) {
        this.$vs.loading();
        this.$store
          .dispatch("attendeeManagement/changeStatus", {
            data: selectedRows,
            Status: Status,
          })
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Status",
              text: res.message,
            });
            this.gridApi.deselectAll();
            this.$vs.loading.close();
            this.$store.dispatch("attendeeManagement/fetchAttendees");
          })
          .catch((err) => {
            //console.error(err)
            this.$vs.loading.close();
          });
      } else {
        this.$vs.dialog({
          type: "alert",
          position: "top-center",
          color: "warning",
          title: "Status",
          text: "Please Select a Row",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    before_save() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.saveMail();
        }
      });
    },
    saveMail() {
      if (this.selectedMailPath && this.MailSubject) {
        this.$vs.loading();
        this.$store
          .dispatch("attendeeManagement/saveMail", {
            html: this.MailHtml,
            subject: this.MailSubject,
            tplpath: this.selectedMailPath,
          })
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: "success",
              title: "Mail Saved",
              text: res.message,
            });
            this.$vs.loading.close();
          })
          .catch((err) => {
            //console.error(err)
            this.$vs.loading.close();
          });
      } else {
        this.$vs.notify({
          position: "top-center",
          color: "warning",
          text: "Template and Subject mandatory! ",
        });
      }
    },
    sendMail() {
      let selectedRows = this.gridApi.getSelectedRows();
      if (selectedRows.length > 400) {
        this.$vs.notify({
          //type: "alert",
          position: "top-center",
          color: "warning",
          //title: "Status",
          text: "Mail cannot be sent more than 400 attendee at a time!",
          //acceptText: "OK",
        });
        return false;
      }
      selectedRows.map((row) => {
        //console.log(row);
        this.mailRecepients.push(row.AttendeeId);
      });
      if (this.mailRecepients.length && this.MailSubject) {
        this.$vs.loading();
        this.$store
          .dispatch("attendeeManagement/sendMail", {
            data: this.mailRecepients,
            subject: this.MailSubject,
            tplpath: this.selectedMailPath,
          })
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: "success",
              title: "Mail Sent",
              text: res.message,
            });
            this.mailRecepients = [];
            this.gridApi.deselectAll();
            this.$vs.loading.close();
          })
          .catch((err) => {
            //console.error(err)
            this.$vs.loading.close();
          });
      } else {
        //alert("Please Select Recepient!");
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Recepient",
          text: "Please Select Recepient! ",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
      this.popupActiveMail = false;
    },
    sendMailQR() {
      if (this.qrRecipients && this.MailSubject) {
        this.$vs.loading();
        this.$store
          .dispatch("attendeeManagement/sendMail", {
            data: this.mailRecepients,
            subject: this.MailSubject,
            tplpath: this.selectedMailPath,
          })
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: "success",
              title: "Mail Sent",
              text: res.message,
            });
            this.qrRecipients = null;
            this.$vs.loading.close();
          })
          .catch((err) => {
            //console.error(err)
            this.$vs.loading.close();
          });
      } else {
        //alert("Please Select Recepient!");
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Recepient",
          text: "Please Select Recepient! ",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
      this.popupActiveMailQR = false;
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();

      // Reset Filter Options
      this.roleFilter =
        this.statusFilter =
        this.isVerifiedFilter =
        this.departmentFilter =
          {
            label: "All",
            value: "all",
          };

      this.$refs.filterCard.removeRefreshAnimation();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    addRecord() {
      this.$router.push("/event/attendee/add").catch(() => {});
    },
    async openAddUserPopup() {
      await this.fetch_attendee_data(null);
    },
    fetch_attendee_data(attendeId) {
      this.$store
        .dispatch("attendeeManagement/fetchAttendee", attendeId)
        .then((res) => {
          debugger;
          vm.attendeeKey++;
          console.log("attendee_data===", res.data);

          vm.attendee_data = res.data;
          vm.attendee_data.DefaultCheckinRole = "";
          debugger;
          if (
            vm.attendee_data.CheckinRoles &&
            vm.attendee_data.CheckinRoles.length > 0
          ) {
            vm.attendee_data.DefaultCheckinRole =
              vm.attendee_data.CheckinRoles[0];
          }
          vm.popupAddUser = true;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    saveAttendeeSuccess(mode) {
      vm.popupAddUser = false;
      if (mode == 0) {
        this.userSaveSuccessMsg = "The new user has been successfully added.";
        this.popupAddUserSuccess = true;
      } else {
        this.userSaveSuccessMsg = "The user has been successfully updated.";
        this.popupAddUserSuccess = true;
      }
      this.$vs.loading();
      this.$store.dispatch("attendeeManagement/fetchAttendees").then((res) => {
        this.pageLoaded = true;
        this.$vs.loading.close();
      });
    },
    cancelAddAttendee() {
      vm.popupAddUser = false;
    },
    deleteRecord() {
      this.selectedFilter = null;
      this.attendeeData_duplicate = [];
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      if (selectedRows.length) {
        const { value: text } = Swal.fire({
          title: "Do you want to Delete these Attendee's ?",
          input: "text",
          inputPlaceholder: "Type 'delete' and hit the Submit button",
          showCancelButton: true,
          confirmButtonText: "Submit",
          inputValidator: (value) => {
            if (value.toLocaleLowerCase().trim() == "delete") {
              this.deleteRecords();
            } else {
              return "Try again! Please type 'delete' and hit Submit.";
            }
          },
        });
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Recepient",
          text: "Please Select Record!",
          acceptText: "OK",
        });
      }
    },
    deleteRecords() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      this.$vs.loading();
      this.$store
        .dispatch("attendeeManagement/removeMultiRecords", {
          data: selectedRows,
        })
        .then((res) => {
          //alert(res.message)
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Delete",
            text: res.message,
          });
          this.gridApi.deselectAll();
          this.$vs.loading.close();
          this.$store.dispatch("attendeeManagement/fetchAttendees");
        })
        .catch((err) => {
          //console.error(err)
          this.$vs.loading.close();
          this.$vs.notify({
            color: "warning",
            position: "top-center",
            title: "Delete",
            text: err.message,
          });
        });
    },
    UploadAttendee: function () {
      var files = document.getElementById("attendee_file").files;
      bu.initVueComps(this.$vs);
      bu.initCheckinModuleActiveStatus(vm.enableCheckinModule);
      if (vm.enableCheckinModule) {
        bu.StartUploadPrecss(files, "user");
      } else {
        bu.StartUploadPrecss(files, "attendee");
      }
    },
    loggedInUsersFilter: function () {
      this.selectedFilter = "Login";
      this.attendeeData_duplicate = [];
      var filterData = [];
      var date = new Date();
      var currentDate = new Date(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        0,
        0,
        0
      );
      var cn = ls.getSessionEventCollectionName();
      this.$vs.loading();
      let query = con.eventDB
        .collection(cn)
        .doc("Analytics")
        .collection("UserLogin")
        .where("actionType", "==", "action")
        .where("timestamp", ">", currentDate)
        .orderBy("timestamp", "desc");
      query.get().then((querySnapshot) => {
        querySnapshot.docs.forEach((doc) => {
          filterData.push(doc.data().UID);
        });
        if (filterData.length > 0) {
          this.userData.map((row) => {
            if (filterData.includes(row.AttendeeId) == true) {
              this.attendeeData_duplicate.push(row);
            }
          });
        } else {
          this.selectedFilter = null;
          this.attendeeData_duplicate = [];
          alert("No One Logged In Today!!");
        }
        this.$vs.loading.close();
      });
    },
    notLoggedInUsersFilter: function () {
      this.selectedFilter = "Not Login";
      this.attendeeData_duplicate = [];
      var filterData = [];
      var date = new Date();
      var currentDate = new Date(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        0,
        0,
        0
      );
      var cn = ls.getSessionEventCollectionName();
      this.$vs.loading();
      let query = con.eventDB
        .collection(cn)
        .doc("Analytics")
        .collection("UserLogin")
        .where("actionType", "==", "action")
        .where("timestamp", ">", currentDate)
        .orderBy("timestamp", "desc");
      query.get().then((querySnapshot) => {
        querySnapshot.docs.forEach((doc) => {
          filterData.push(doc.data().UID);
        });
        this.userData.map((row) => {
          if (filterData.includes(row.AttendeeId) == false) {
            this.attendeeData_duplicate.push(row);
          }
        });
        this.$vs.loading.close();
      });
    },
    CloseFilterLogin: function () {
      this.selectedFilter = null;
      this.attendeeData_duplicate = [];
    },
    saveSettingsData() {
      this.settingsData = {
        DefaultSettingsLoaded: true,
      };
    },
    getAnnouncementMailTpl() {
      let selectedRows = this.gridApi.getSelectedRows();
      if (selectedRows.length > 400) {
        this.$vs.dialog({
          type: "alert",
          position: "top-center",
          color: "warning",
          //title: "Status",
          text: "Mail cannot be sent more than 400 attendee at a time!",
          acceptText: "OK",
        });
      } else {
        this.$vs.loading();
        this.MailHtml = "Loading...";
        this.$store
          .dispatch("attendeeManagement/getAnnouncementMailTemplate")
          .then((res) => {
            this.MailHtml = res.html;
            this.MailSubject = res.subject;
            this.MailHtml = res.html;
            this.$vs.loading.close();
            this.popupActiveMail = true;
          });
      }
    },
    setPreviewMailTemplate(template) {
      if (template == "Reminder") {
        this.previewSelectedTemplate = "Reminder";
        var element2 = document.getElementById("reminderTemp");
        element2.classList.add("active");
        var element = document.getElementById("announcementTemp");
        element.classList.remove("active");
        this.getMailTpl();
      } else {
        this.previewSelectedTemplate = "Announcement";
        var element2 = document.getElementById("reminderTemp");
        element2.classList.remove("active");
        var element = document.getElementById("announcementTemp");
        element.classList.add("active");
        this.getAnnouncementMailTpl();
      }
    },
    cancelMail(val) {
      if (val == "QR") this.popupActiveMailQR = false;
      else this.popupActiveMail = false;
      this.previewSelectedTemplate = "Reminder";
      var element2 = document.getElementById("reminderTemp");
      element2.classList.add("active");
      var element = document.getElementById("announcementTemp");
      element.classList.remove("active");
    },
    generateQR() {
      let ids = this.gridApi.getSelectedRows().map((item) => item.AttendeeId);
      if (ids.length) {
        this.$vs.loading();
        this.$store
          .dispatch(
            "attendeeManagement/generateQR",
            this.attendeeData_duplicate.length == ids.length ? null : ids
          )
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: res.status == 200 ? "success" : "warning",
              position: "top-center",
              text: res.message,
            });
            this.gridApi.deselectAll();
            this.$vs.loading.close();
          })
          .catch((err) => {
            console.error(err);
            this.$vs.loading.close();
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              text: "Something went wrong!",
            });
          });
      } else {
        this.$vs.dialog({
          type: "alert",
          position: "top-center",
          color: "warning",
          title: "Status",
          text: "Please Select a Row",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    getLoginFilterUsers() {
      this.LoginFilterUsers = [];
      if (!this.LoginTypeFilterVal) return false;
      this.$vs.loading();
      console.log();
      if (this.LoginTypeFilterVal == "Active") {
        this.$store
          .dispatch("dashboardManagement/getAllActiveUsers", 8760)
          .then((res) => {
            this.LoginFilterUsers = res;
            this.$vs.loading.close();
          });
      } else if (this.LoginTypeFilterVal == "Inactive") {
        this.$store
          .dispatch("dashboardManagement/getAllInactiveUsers", 8760)
          .then((res) => {
            this.LoginFilterUsers = res;
            this.$vs.loading.close();
          });
      }
    },
    fetchDesignations() {
      debugger;
      vm.$store
        .dispatch("checkinRoleManagement/fetchDesignations")
        .then((res) => {
          debugger;
          if ((res.status = 200)) {
            vm.designationList = [];

            if (res.data && res.data.length > 0) {
              res.data[0].map(function (item) {
                if (item.IsPublished) {
                  vm.designationList.push(item);
                }
              });
            }

            if (vm.designationList && vm.designationList.length > 0) {
              vm.designationList.sort((a, b) => {
                console.log("a====", a.CreatedDate["_seconds"]);

                const aDate = new Date(a.CreatedDate["_seconds"] * 1000);
                const bDate = new Date(b.CreatedDate["_seconds"] * 1000);
                return bDate.getTime() - aDate.getTime();
              });
            }
          }
        })
        .catch((err) => {
          debugger;
          // this.$vs.notify({
          //   color: "warning",
          //   position: "top-center",
          //   title: "Job Title",
          //   text: "Something went wrong!",
          // });
        });
    },
  },
  mounted() {
    this.gridOptions.api.showLoadingOverlay();
    this.gridApi = this.gridOptions.api;

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
  },
  created() {
    vm = this;
    if (this.enableCheckinModule) {
      bus.$on("editAttendee", async (attendeeId) => {
        await this.fetch_attendee_data(attendeeId);
      });
    }
    let urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("locId")) {
      vm.paramLocationId = urlParams.get("locId");
    }
    /*if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }
    this.$store.dispatch('userManagement/fetchUsers').catch(err => { console.error(err) })*/
    if (!moduleAttendeeManagement.isRegistered) {
      this.$store.registerModule(
        "attendeeManagement",
        moduleAttendeeManagement
      );
      moduleAttendeeManagement.isRegistered = true;
    } /*else {
      this.$store
        .dispatch("attendeeManagement/reInitAttendeeSession")
        .then(res => {})
        .catch(err => {
          alert("Something went wrong!");
        });
    }*/
    this.$vs.loading();

    if (!moduleEventManagement.isRegistered) {
      this.$store.registerModule("eventManagement", moduleEventManagement);
      moduleEventManagement.isRegistered = true;
    }
    if (!moduleTicketManagement.isRegistered) {
      this.$store.registerModule("TicketManagement", moduleTicketManagement);
      moduleTicketManagement.isRegistered = true;
    }
    if (!moduleMailtplManagement.isRegistered) {
      this.$store.registerModule("mailtplManagement", moduleMailtplManagement);
      moduleMailtplManagement.isRegistered = true;
    }
    if (!moduleDashboardManagement.isRegistered) {
      this.$store.registerModule(
        "dashboardManagement",
        moduleDashboardManagement
      );
      moduleDashboardManagement.isRegistered = true;
    }
    this.getRegistrationTypeFilters();
    if (vm.enableCheckinModule) {
      if (!moduleCheckinLocationManagement.isRegistered) {
        this.$store.registerModule(
          "checkinlocationManagement",
          moduleCheckinLocationManagement
        );
        moduleCheckinLocationManagement.isRegistered = true;
      }
      this.$store
        .dispatch("checkinlocationManagement/fetchGeoCheckinLocations")
        .then((res) => {
          console.log("res---location", res);

          res.data[0].map(function (item) {
            if (item.IsPublished) {
              vm.locationList.push({
                LocationId: item.LocationId,
                Name: item.Name,
                ImageUrl: item.ImageUrl,
              });
            }
          });
          // vm.locationList = res.data[0];
        });
      debugger;
      if (!moduleCheckinRoleManagement.isRegistered) {
        this.$store.registerModule(
          "checkinRoleManagement",
          moduleCheckinRoleManagement
        );
        moduleCheckinRoleManagement.isRegistered = true;
      }
      vm.fetchCheckinRoles();
      setTimeout(() => {
        vm.fetchDesignations();
      }, 1000);
    }

    this.$store.dispatch("attendeeManagement/getSettings").then((res) => {
      this.settingsData = res;
      this.$store.dispatch("attendeeManagement/fetchAttendees").then((res) => {
        this.pageLoaded = true;
        this.$vs.loading.close();
      });
    });
  },
  destroyed() {
    bus.$off("editAttendee");
  },
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
  // .vs-button-backgroundx{
  //   background: transparent !important;
  // }
}
</style>